import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Homepage from "./pages/Homepage";
import Signup from "./pages/Signup";
import Signin from "./pages/Signin";
import SelectUser from "./pages/SelectUser";
import StudentInfo from "./pages/StudentInfo";
import StudentInfo2 from "./pages/StudentInfo2";
import StudentInfo3 from "./pages/StudentInfo3";
import SchoolInfo from "./pages/SchoolInfo";
import HospitalInfo from "./pages/HospitalInfo";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import SchoolProfile from "./pages/SchoolProfile";
import AddStudent from "./pages/AddStudent";
import SchoolDashboard from "./pages/SchoolDashboard";
import StudentDashboard from "./pages/StudentDashboard";
import Faq from "./pages/Faq";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsConditions from "./pages/TermsConditions";
import ContactUs from "./pages/ContactUs";
import HospitalDashboard from "./pages/HospitalDashboard";
import AdminApproval from "./pages/AdminApproval";
import SchoolFiles from "./pages/SchoolFiles";
import PendingApproval from "./pages/PendingApproval";
import ViewStudentFiles from "./pages/ViewStudentFiles";
import StudentFiles from "./pages/StudentFiles";
import AboutUs from "./pages/AboutUs";
import StudentProfile from "./pages/StudentProfile";
import HospitalProfile from "./pages/HospitalProfile";
import SchoolRequests from "./pages/SchoolRequests";
import StudentSubfolder from "./pages/StudentSubfolder";
import DataSubfolder from "./pages/DataSubfolder";
import SeniorSubfolder from "./pages/SeniorSubfolder";
import MiscellaneousSubfolder from "./pages/MiscellaneousSubfolder";
import StudentSubfolderFile from "./pages/StudentSubfolderFile";
import { PrivateRoute } from "./PrivateRoute";
import SubAdmin from "./components/common-components/Sub-admin";
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "./style.css";
import SignatureDocsTable from "./components/common-components/FileSystem/signatureDocs";
import StudentListTables from "./components/common-components/studentTable";
import RotaionReqTable from "./components/common-components/FileSystem/RotationReqSch";
import ProgramDetails from "./components/common-components/FileSystem/ProgramDetails";
import StudentDetailTable from "./components/common-components/FileSystem/StudentDetails";
const App = () => {

    return (
        <div>

            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<Homepage />} />
                    <Route path="/signup" element={<Signup />} />
                    <Route path="/signin" element={<Signin />} />
                    <Route
                        path="/forgot-password/:type"
                        element={<ForgotPassword />}
                    />

                    <Route path="/select-user"
                        element={
                            <PrivateRoute>
                                <SelectUser />
                            </PrivateRoute>
                        } />
                    <Route path="/student-info" element={
                        <PrivateRoute>
                            <StudentInfo />
                        </PrivateRoute>
                    } />
                    <Route path="/student-info2" element={
                        <PrivateRoute>
                            <StudentInfo2 />
                        </PrivateRoute>
                    } />
                    <Route path="/student-info3" element={
                        <PrivateRoute>
                            <StudentInfo3 />
                        </PrivateRoute>
                    } />
                    <Route path="/school-info" element={
                        <PrivateRoute>
                            <SchoolInfo />
                        </PrivateRoute>
                    } />
                    <Route path="/hospital-info" element={
                        <PrivateRoute>
                            <HospitalInfo />
                        </PrivateRoute>
                    } />

                    <Route path="/reset-password/:token" element={<ResetPassword />} />
                    <Route path="/school-profile" element={<SchoolProfile />} />
                    <Route path="/add-student" element={<AddStudent />} />
                    <Route
                        path="/school-dashboard"
                        element={
                            <PrivateRoute>
                                <SchoolDashboard />
                            </PrivateRoute>
                        }
                    />

                    <Route
                        path="/:who/:role/:id"
                        element={
                            <PrivateRoute>
                                <SubAdmin />
                            </PrivateRoute>
                        }
                    />


                    <Route
                        path="/Student/:programId/programs/:school_id"
                        element={
                            <PrivateRoute>
                                <StudentListTables />
                            </PrivateRoute>
                        }
                    />

                    <Route
                        path="/student-dashboard"
                        element={
                            <PrivateRoute>
                                <StudentDashboard />
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/hospital-dashboard"
                        element={
                            <PrivateRoute>
                                <HospitalDashboard />
                            </PrivateRoute>
                        }
                    />

                    <Route path="/faq" element={<Faq />} />
                    <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                    <Route
                        path="/terms-conditions"
                        element={<TermsConditions />}
                    />
                    <Route path="/contact-us" element={<ContactUs call={"false"} />} />
                    <Route path="/schedule_call" element={<ContactUs call={"true"} />} />

                    <Route path="/admin-approval" element={<AdminApproval />} />
                    <Route path="/school-files/:folderId" exact element={<SchoolFiles />} />
                    <Route path="/school-files/:folderId/:createdBy_id" exact element={<SchoolFiles />} />
                    <Route path="/contracts/:folderId" exact element={<SignatureDocsTable />} />
                    <Route path="/rotation-req/:school_id/:program_id" exact element={<RotaionReqTable />} />
                    <Route path="/program-files/:school_id" exact element={<ProgramDetails />} />
                    <Route path="/Student-details/:rotation_req_id" exact element={<StudentDetailTable />} />
                    <Route path="/pending-approval/:id" element={<PendingApproval />} />
                    <Route path="/view-student-files" element={<ViewStudentFiles />} />
                    <Route path="/student-files" element={<StudentFiles />} />
                    <Route path="/student-files/:userid" element={<StudentFiles />} />
                    <Route path="/about-us" element={<AboutUs />} />
                    <Route
                        path="/student-profile/:tab"
                        element={<StudentProfile activekey={"home"} />}
                    />
                    <Route
                        path="/change-password/:tab"
                        element={<StudentProfile activekey={"pwsd"} />}
                    />
                    <Route
                        path="/hospital-profile"
                        element={<HospitalProfile />}
                    />
                    <Route
                        path="/school-requests"
                        element={<SchoolRequests />}
                    />
                    <Route
                        path="/student-subfolder"
                        element={<StudentSubfolder />}
                    />
                    <Route
                        path="/data-subfolder"
                        element={<DataSubfolder />}
                    />
                    <Route
                        path="/senior-subfolder"
                        element={<SeniorSubfolder />}
                    />

                    <Route
                        path="/miscellaneous-subfolder"
                        element={<MiscellaneousSubfolder />}
                    />

                    <Route
                        path="/student-subfolder-file"
                        element={<StudentSubfolderFile />}
                    />
                </Routes>
            </BrowserRouter>
        </div>
    );
};

export default App;
